module.exports = __webpack_public_path__ + "img/testimonial-ruta-aldonyte.0ba836bd.png";